export default __webpack_public_path__ + "28ebb513dfeb9b460b99a8a79900957b.png";